import taapi from './taapi'
import { downloadFile } from '../common/downloadHelpers'
import type { KbItem, KbDocSource } from '../types'
export type { KbItem, KbFileView, BatchProcessUploadDocWebResult } from '../types/kbitem'
export type { KbDocPage, KbDocSource } from '../types/kbdoc'

// ─── Utilities ───────────────────────────────────────────────────────────────

export function treeNodeAt(root: KbItem, path: string): KbItem {
  if (path === '/') return root
  const parts = path.replace(/^\//, '').split('/').filter(Boolean)
  let node = root
  for (const part of parts) {
    const found = node.child?.find(c => c.name === part)
    if (!found) return root
    node = found
  }
  return node
}

export function shortDate(iso?: string): string {
  if (!iso) return ''
  return iso.slice(0, 10)
}

export function fileExt(name: string): string {
  const dot = name.lastIndexOf('.')
  return dot >= 0 ? name.slice(dot + 1).toUpperCase() : ''
}

// ─── API ─────────────────────────────────────────────────────────────────────

export async function fetchDirectory(dirsha: string | null, projectsha: string | null): Promise<KbItem[]> {
  const result = await taapi.post('/api2/kbdirectory', { dirsha, projectsha })
  return result?.fsitems ?? []
}

export async function fetchInit(currentpath: string): Promise<KbItem | null> {
  const result = await taapi.post('/api2/kbinit', { currentpath })
  return result?.fileSystemTree ?? null
}

export async function addFolder(dirname: string, dirsha?: string): Promise<{ success: boolean; msg?: string }> {
  const result = await taapi.post('/api2/kbaddfolder', { dirname, dirsha })
  return { success: !!result?.success, msg: result?.msg }
}

export async function deleteFolder(dirsha: string, path: string): Promise<any> {
  return await taapi.post('/api2/kbdelfolder', { dirsha, path })
}

export async function renameFolder(newdirname: string, dirsha: string, path: string): Promise<void> {
  await taapi.post('/api2/kbrenamefolder', { newdirname, dirsha, path })
}


export async function deleteDocBatch(docshas: string[]): Promise<string[]> {
  const result = await taapi.post('/api2/kbdeldocbatch', { docshas })
  return result?.taskshalist ?? []
}

export async function fetchDocSections(docsha: string, activepage: number): Promise<KbDocSource | null> {
  const result = await taapi.get('/api2/kbdocsections', { docsha, activepage: String(activepage) })
  return result ?? null
}

export async function saveDocPage(page: number, pagesha: string, filesha: string, html: string): Promise<void> {
  await taapi.post('/api2/kbsavetext', { page, pagesha, filesha, htmlcontent: html })
}

export async function downloadDoc(docsha: string, name: string): Promise<void> {
  const result = await taapi.post('/api2/kbdownload', { docsha })
  downloadFile({
    data: (result?.doc ?? '') as string,
    base64: true,
    filename: result?.filename ?? name,
  })
}
